import { NgClass, NgStyle, SlicePipe } from '@angular/common'
import { Component, inject, input, OnInit, output } from '@angular/core'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'

import { Button } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'

import { Product } from 'app/_shared/interfaces/Product'
import { ProductVariant } from 'app/_shared/interfaces/ProductVariant'
import { UsdPipe } from 'app/_shared/pipes/currency.pipe'
import { PricePipe } from 'app/_shared/pipes/price.pipe'
import { AppConfigService } from 'app/app-config.service'
import { isLightColor, compareColors } from 'app/pages/product/utils/color.utils'

@Component({
  selector: 'app-product-item',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgStyle,
    PricePipe,
    UsdPipe,
    SlicePipe,
    NgClass,
    Button,
    DialogModule
  ],
  templateUrl: './product-item.component.html',
  styleUrl: './product-item.component.scss'
})
export class ProductItemComponent implements OnInit {
  appConfigService = inject(AppConfigService)

  product = input.required<Product>()
  noLink = input<boolean>(false)
  cartIcon = input<boolean>(false)
  hidePrice = input<boolean>(false)
  cartClick = output<Product>()

  currentImage!: string
  selectedVariant: ProductVariant | null = null
  sortedVariants: ProductVariant[] = []
  protected disablePrices: boolean

  constructor(private router: Router) {}

  ngOnInit() {
    this.disablePrices = !!this.appConfigService.getAppConfig.disabled_prices

    const prod = this.product()

    // If variants exist, sort them using custom comparator
    if (prod.product_variants && prod.product_variants.length > 0) {
      this.sortedVariants = prod.product_variants
        .slice()
        .sort((a, b) => compareColors(a.color, b.color))
    }

    // Set the initial image to the main thumbnail
    this.currentImage =
      prod.product_thumbnail?.full_path ||
      (prod.is_gift_card && 'assets/images/giftcard.png') ||
      (prod.is_custom && 'assets/images/custom-product.png') ||
      'assets/demo/images/product/t-shirt-placeholder.png'
  }

  selectVariant(variant: ProductVariant) {
    // If the clicked variant is already selected, deselect it
    if (this.selectedVariant?.id === variant.id) {
      this.selectedVariant = null
      this.currentImage =
        this.product().product_thumbnail?.full_path ||
        'assets/demo/images/product/t-shirt-placeholder.png'
    } else {
      // Otherwise, set the selected variant and update the image accordingly
      this.selectedVariant = variant
      this.currentImage =
        variant.variant_thumbnail?.full_path || 'assets/demo/images/product/t-shirt-placeholder.png'
    }
  }

  navigateToProduct() {
    this.router.navigate(['/products', this.product().slug], {
      state: { variantId: this.selectedVariant ? this.selectedVariant.id : null }
    })
  }

  protected readonly isLightColor = isLightColor

  handleCartClick() {
    if (this.cartClick) {
      this.cartClick.emit(this.product())
    }
  }
}
